import api from "@/api";
import { v4 as uuidv4 } from 'uuid';

const ANALYTICS_ID_KEY = 'eleicaonet_analytics_id';

export default {
  /**
   * Get or create anonymous ID
   */
  getAnonymousId() {
    let id = localStorage.getItem(ANALYTICS_ID_KEY);
    if (!id) {
      id = uuidv4();
      localStorage.setItem(ANALYTICS_ID_KEY, id);
    }
    return id;
  },

  /**
   * Record page access
   */
  async trackAccess(idEleicao, path, isAuthenticated = false) {
    try {
      const anonymousId = this.getAnonymousId();
      await api.post("AcessoHotsites/registrar", {
        idEleicao,
        anonymousId,
        path,
        authenticated: isAuthenticated
      });
    } catch (error) {
      console.error("Failed to track access:", error);
    }
  }
};
